export class AuthPerm {

  id?: string | null;
  parentId?: string | null;
  hierarchyId?: string | null;
  hierarchyLinkId?: string | null;
  authLinkId?: string | null;
  intAppCode?: string | null;
  name?: string = "";
  sortOrder?: number = 1;
  isActive?: boolean = true;
  isConfigLabel?: boolean = false;
  licenseId?: string | null;
  target?: string = "";
  info?: string = "";
  appTag?: string = "";
  appTagId?: string | null;
  metaData?: string = "";
  description?: string = "";
  intDescription?: string = "";
  moduleId?: string | null;
  moduleTarget?: string = "";
  moduleInfo?: string = "";
  moduleAppTagId?: string | null;
  moduleHierarchyName?: string = "";
  pbiWorkSpaceId?: string | null;
  pbiDashboardId?: string | null;
  pbiChartId?: string | null;
  pbiPageSection?: string = "";
  pbiNavigation?: boolean = false;
  isLocked?: boolean = false;

  lastModifiedBy?: string | null;
  lastModifiedOn?: Date | null;

  HierarchyName?: string | null;
  ModuleName?: string | null;
  LastModifiedByName?: string | null;
  
}
